<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-clipboard-list-check text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Año Escolar Extendido
        </span>
      </div>
    </div>
    <div class="row py-3 mr-md-0">
      <div class="col-12">
        <custom-callout
          class-main="mt-3 rounded"
          :controlled="true"
          :opened="showContractRequestTab"
          @click:open="
            () => {
              onCloseHandler();
            }
          "
        >
          <div class="row py-4 mr-md-0">
            <div class="col-12 col-md-3 col-lg-3 col-xl-3 border-right">
              <div>
                <div class="font-18 font-weight-bold">
                  <ul class="status-aee m-0">
                    <li>{{ data.requestAee.status }}</li>
                  </ul>
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ data.requestAee.requestNumber }}
                </div>
              </div>
            </div>
            <div class="col-12 col-md-9">
              <div class="row pt-2">
                <div class="col-12 col-md-3 pl-4">
                  <div>
                    <span class="color-gray-6 d-block font-14">
                      Año Académico:
                    </span>
                    <span class="font-16 color-black">
                      {{ data.requestAee.academicYear }}
                    </span>
                  </div>
                </div>
                <div class="col-12 col-md-6 pl-4 mt-2 mt-md-0">
                  <div>
                    <span class="color-gray-6 d-block font-14">
                      Razón de Denegado:
                    </span>
                    <span class="font-16 color-black">
                      {{ data.requestAee.reasons }}
                    </span>
                  </div>
                </div>
                <div
                  class="col-12 col-md-3 d-inline d-md-flex align-items-center justify-content-end mt-2 mt-md-0"
                >
                  <drop-down class="ml-2" :items="actionItems(data)" />
                </div>
              </div>
            </div>
          </div>
          <template #edition>
            <div v-if="showContractRequestTab" class="p-2 mt-1">
              <div class="bg-white rounded p-md-3 px-md-4">
                <section-title
                  container-class="m-0 mr-3 mt-3"
                  content="Documentos Añadidos"
                  :has-line="true"
                />
                <custom-result-not-found
                  v-if="aeeDocuments.length === 0"
                  text="No cuenta con documentos en el sistema."
                />
                <div
                  v-for="(item, index) in aeeDocuments"
                  :key="`${index}-${item.documentId}`"
                >
                  <custom-callout
                    class-main="mt-3"
                    :has-border="true"
                    :has-gradient="false"
                    :has-toggle="false"
                  >
                    <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
                      <div class="col-12 col-md-6 my-2">
                        <div class="color-gray-6 font-14">Documento:</div>
                        <div class="color-black font-16">
                          {{ item.documentTypeName | empty }}
                        </div>
                      </div>
                      <div class="col-12 col-md-3 my-2">
                        <div class="color-gray-6 font-14">Archivo:</div>
                        <div class="color-black font-16">
                          {{ item.filename | empty }}
                        </div>
                      </div>
                      <div class="col-12 col-md-3 text-sm-right mt-3 mt-sm-1">
                        <action-button
                          id="btn-download-document"
                          class="btn-action-size"
                          :disabled="!item.documentId"
                          i="fas fa-file-download"
                          variant="success"
                          @click="() => onDownloadFileHandler(item)"
                        />
                      </div>
                    </div>
                  </custom-callout>
                </div>
              </div>
            </div>
          </template>
        </custom-callout>
      </div>
    </div>
  </div>
</template>

<script>
//constants
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import CustomCallout from 'custom-callout';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'ContractAee',
  components: {
    CustomCallout,
    SectionTitle,
    ActionButton,
    CustomResultNotFound,
    DropDown,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      model: {},
      editingDate: false,
      showContractRequestTab: false,
      results: [],
    };
  },
  mixins: [alertMixin],
  computed: {
    requestNumber() {
      return this.data.requestAee.requestNumber;
    },
    createdDate() {
      return this.data.requestAee.createdDate;
    },
    comments() {
      return this.data.requestAee.comments;
    },
    aeeDocuments() {
      return this.data.requestAee.documents;
    },
    actionItems() {
      return () => {
        return [
          {
            label: 'Ver Documento',
            icon: 'fas fa-file-import color-green',
            click: () => {
              this.onCloseHandler();
              this.showContractRequestTab = true;
            },
            visible: true,
          },
          {
            label: 'Solicitar Año Escolar Extendido',
            icon: 'fas fa-solid fa-calendar-arrow-down color-green',
            click: () => this.$emit('on-view-request-aee'),
          },
        ];
      };
    },
  },
  methods: {
    onDownloadFileHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
    onCloseHandler() {
      this.showContractRequestTab = !this.showContractRequestTab;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/brand_variables.scss';
.status-aee {
  list-style: none;
  padding-left: 20px;
}

.status-aee li {
  margin-bottom: 5px;
  position: relative;
}

.status-aee li::before {
  content: '•';
  color: $yellow;
  position: absolute;
  left: -15px;
}
</style>
